import { configuration } from 'config';

const {
    guForm: { maxFileSizeInMb },
} = configuration;

export async function fileUploadHandler(
    e,
    setFieldError,
    setFieldTouched,
    formName,
    fieldName,
    value,
    setValues
) {
    let fileList = e;
    let fileListLength = fileList.length;

    setFieldTouched(formName, fieldName);

    if (!fileListLength) return;

    const errors = [];

    const numberOfFiles = Object.keys(value || {}).length + fileListLength;

    if (numberOfFiles > 5) {
        errors.push(
            `You are trying to upload too many files. Maximum 5 files allowed. `
        );
        fileListLength = 5 - Object.keys(value || {}).length;
    }

    if (fileList.length)
        for (let i = 0; i < fileListLength; i++) {
            const type = fileList[i].type.split('/').at(0);
            const name = fileList[i].name;
            const sizeInMb = fileList[i].size / (1024 * 1024);

            if (sizeInMb > maxFileSizeInMb) {
                errors.push(
                    `File size too big. Max file size allowed is ${maxFileSizeInMb}mb`
                );
                if (fileListLength < fileList.length) ++fileListLength;

                continue;
            }

            if (value?.hasOwnProperty(name)) {
                errors.push(
                    'You tried to upload same file twice. Only one copy will be uploaded.'
                );
                if (fileListLength < fileList.length) ++fileListLength;

                continue;
            }

            if (type !== 'image' && type !== 'video' && type !== 'audio') {
                errors.push(
                    `Only image, video and audio files are allowed. All other files are discarded.`
                );
                if (fileListLength < fileList.length) ++fileListLength;

                continue;
            }

            const reader = new FileReader();
            reader.onload = (file) => {
                setValues((state) => ({
                    ...state,
                    [formName]: {
                        ...state[formName],
                        [fieldName]: {
                            ...state[formName][fieldName],
                            ...{
                                [name]: {
                                    file: fileList[i],
                                    renderUrl: file.target.result,
                                    type,
                                },
                            },
                        },
                    },
                }));
            };
            reader.readAsDataURL(fileList[i]);
            setFieldError(formName, fieldName, false);
        }

    if (errors.length) {
        setFieldError(formName, fieldName, [...new Set(errors)]);
    }
}

export function getDateAndShift() {
    const torontoDateTimeString = new Date().toLocaleString('en-CA', {
        timeZone: 'America/Toronto',
        hour12: false,
    });

    const belgradeDateTimeString = new Date().toLocaleString('en-CA', {
        timeZone: 'Europe/Belgrade',
        hour12: false,
    });

    const [dateString] = torontoDateTimeString.split(',');
    const [, time] = belgradeDateTimeString.split(',');

    const hour = +time.trim().slice(0, 2);
    let shift;
    switch (true) {
        case hour >= 6 && hour < 14:
            shift = 'MORNING';
            break;
        case hour >= 14 && hour < 22:
            shift = 'DAY';
            break;
        default:
            shift = 'NIGHT';
    }

    return [dateString, shift];
}
